import { isAssignableExpressionNull } from '../../../../../expressions/datatype/isAssignableExpressionNull';
import { IReference } from '../../../../../expressions/references/IReference';
import { ReferenceSchema } from '../../../../../expressions/validation/ReferenceSchema';
import { IBaseWidget } from '../../../../IBaseWidget';

export interface IConfirmableConfig {
  confirmation?: IReference | null;
}

export interface IConfirmableWidget extends IBaseWidget, IConfirmableConfig {}

export function isConfirmableWidget(
  widget: IBaseWidget,
): widget is IConfirmableWidget {
  return widget && 'confirmation' in widget;
}

export const ConfirmationConfigSchema = ReferenceSchema.label('Conferma')
  .nullable()
  .when(['defaultValue'], ([defaultValue], schema) =>
    isAssignableExpressionNull(defaultValue)
      ? schema.enabled(false)
      : schema.enabled(true),
  );
